import { startOfDay } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export const getStartOfDayForPrisma = () => {
  const timeZone = "America/Bogota";
  const now = new Date();
  const zonedDate = toZonedTime(now, timeZone);
  const startOfZonedDay = startOfDay(zonedDate);
  return startOfZonedDay.toISOString();
};
